import { useContext, useMemo } from 'react';

import {
  PaginationContext,
  SortContext,
  InventoryTable,
} from 'dash-ui';
import { PropertyFragment, useGetUnitsQuery } from 'gql/generated.graphql';

function InventoryTableSection({
  filter,
}: {
  filter: { property: PropertyFragment };
}) {
  const { _id: propertyId, defaultInventoryDetails } = filter.property;

  const {
    setTotal,
    state: paginationState,
    getRefetchProps,
  } = useContext(PaginationContext);
  const { state: sort } = useContext(SortContext);

  const { skip, limit } = getRefetchProps(paginationState);

  // Adjust default sort parameters
  if (![-1, 1].includes(sort.sortOrder)) sort.sortOrder = 1;
  if (sort.fieldName === '') sort.fieldName = 'name';

  const {
    data: result,
    refetch,
    loading,
  } = useGetUnitsQuery({
    variables: {
      sort: [sort],
      pagination: { skip, limit },
      filter: { propertyId },
    },
    onCompleted: (data) => {
      const total = data?.getUnits?.totalCount || 0;
      setTotal(total)
    },
  });

  const { data } = useMemo(
    () => ({
      data: result?.getUnits?.collection || [],
    }),
    [result]
  );

  return (
    <InventoryTable
      data={data}
      loading={loading}
      emptyStateText={defaultInventoryDetails || ''}
    />
  );
}

export default InventoryTableSection;
